import { render, staticRenderFns } from "./MoveJobs.vue?vue&type=template&id=da98c75a&"
import script from "./MoveJobs.vue?vue&type=script&lang=ts&"
export * from "./MoveJobs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports